module.exports = __webpack_public_path__ + "30851e320cf0571205733d7eead8e5d4.svg";